import { render, staticRenderFns } from "./view_detail_cod_wallet.vue?vue&type=template&id=04a8548b"
import script from "./view_detail_cod_wallet.vue?vue&type=script&lang=js"
export * from "./view_detail_cod_wallet.vue?vue&type=script&lang=js"
import style0 from "./view_detail_cod_wallet.vue?vue&type=style&index=0&id=04a8548b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports